import ApiService from '../../../../services/ApiService'
import Utils from '../../../../Utils/FormatDate'
import ManageTask from '../../Tasks/components/ManageTask.vue'
import ManageExternalFileControl from '../../ExternalFileControl/components/manageExternalFileControl/manageExternalFileControl.vue'
import moment from 'moment'

export default {
  components: {
    ManageTask,
    ManageExternalFileControl,
  },
  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
  },

  data: () => ({
    apiService: new ApiService(),
    toggleColorPrimary: 0,
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    type: 'month',
    showListYear: false,
    start: null,
    end: null,
    yearTitle: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    name: null,
    details: null,
    color: '#1976D2',
    dialog: false,
    currentlyEditing: null,
    dialogKey: false,
    taskDialog: false,
    externalFileDialog: false,
    institutionId: null,
    currentTask: {},
    tasks: [],
    equipment: [],
    inspections: [],
    currentEquipment: {},
    contacts: [],
    calibrationPattern: [],
    calibrationV2Pattern: [],
    currentExternalFile: {},
    externalFilesControl: [],
    eventsYear: [],
    months: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
  }),

  computed: {
    title() {
      const { start, end } = this
      if (!start || !end) {
        return ''
      }

      const startMonth = this.monthFormatter(start)
      const startYear = start.year
      const startDay = start.day
      const startWeek = Utils.startOfWeek(start.date)
      const endWeek = Utils.endOfWeek(end.date)

      switch (this.type) {
        case 'month':
          return `${this.$t(startMonth)} ${startYear}`
        case 'week':
          return `${Utils.moment(startWeek)} - ${Utils.moment(endWeek)}`
        case 'day':
          return `${startDay} ${startMonth} ${startYear}`
      }
      return ''
    },

    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC',
        month: 'long',
      })
    },
  },

  mounted() {
    this.$refs.calendar.checkChange()
  },

  methods: {
    showMonth() {
      this.type = 'month'
      this.showListYear = false
    },

    showWeek() {
      this.type = 'week'
      this.showListYear = false
    },

    showDay() {
      this.type = 'day'
      this.showListYear = false
    },

    showYear() {
      this.yearTitle = this.start.year
      this.yearEvents(this.yearTitle)
      this.showListYear = true
    },

    viewDay({ date }) {
      this.focus = date
      this.type = 'day'
    },

    getEventColor(event) {
      return event.color
    },

    getEventTitle(event) {
      switch (event.color) {
        case '#8F8F8F':
          return 'Tarefa'
        case '#238CA5':
          return 'Garantia Equipamento'
        case '#B14949':
          return 'Contrato'
        case '#BBCF20':
          return 'Padrão Calibração'
        case '#426483':
          return 'Controle Doc'
        case '#38B890':
          return 'Rotinas de inspeção'
      }
    },

    parseDate(date) {
      if (date != undefined) {
        return Utils.dateTime(date)
      }
    },

    setToday() {
      this.focus = this.today
    },

    prev() {
      if (this.showListYear) {
        this.yearTitle = this.yearTitle - 1
        this.yearEvents(this.yearTitle)
      } else {
        this.$refs.calendar.prev()
      }
    },

    next() {
      if (this.showListYear) {
        this.yearTitle = this.yearTitle + 1
        this.yearEvents(this.yearTitle)
      } else {
        this.$refs.calendar.next()
      }
    },

    closeDialog() {
      this.taskDialog = false
      this.$router.go()
    },

    openEvent({ nativeEvent, event }) {
      if (event.color !== '#8F8F8F' && event.color !== '#238CA5') {
        this.callEvent(event)
      }
    },

    callEvent(event) {
      switch (event.type) {
        case 0:
          this.currentTask = event.object
          this.taskDialog = true
          this.dialogKey = !this.dialogKey
          break
        case 1:
          this.currentEquipment = event.object
          this.$router.push({
            name: 'editEquipment',
            params: { equipment: this.currentEquipment },
          })
          break
        case 2:
          const contract = event.object
          sessionStorage.setItem('contract', JSON.stringify(contract))
          this.$router.push('/editContract')
          break
        case 3:
          const pattern = event.object
          sessionStorage.setItem('calibrationPattern', JSON.stringify(pattern))
          this.$router.push('/editCalibrationPattern')
          break
        case 4:
          this.currentExternalFile = event.object
          this.externalFileDialog = true
          this.dialogKey = !this.dialogKey
          break
        case 5:
          const patternV2 = event.object
          sessionStorage.setItem(
            'calibrationV2Pattern',
            JSON.stringify(patternV2)
          )
          this.$router.push('/calibration/v2/pattern/manage?id=' + patternV2.id)
          break
      }
    },

    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => (this.selectedOpen = true), 10)
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },

    groupBy(input, key) {
      return input.reduce((acc, currentValue) => {
        let groupKey = currentValue[key]
        if (!acc[groupKey]) {
          acc[groupKey] = []
        }
        acc[groupKey].push(currentValue)
        return acc
      }, {})
    },

    async updateRange({ start, end }) {
      this.start = start
      this.end = end

      Promise.all([
        this.getTasks(start, end),
        this.getEquipment(start, end),
        await this.getContracts(),
        await this.getInspections(start, end),
        await this.getCalibrationPatterns(),
        await this.getCalibrationV2Patterns(),
        await this.getExternalFilesControl(),
      ])

      this.yearEvents(start.year)

      const events = []

      Object.keys(this.tasks).forEach((key) => {
        const tasksPerDay = this.tasks[key]

        events.push({
          type: 0,
          object: { date: key, myInspections: tasksPerDay },
          name: 'Vencimento Tarefa',
          start: key,
          end: key,
          color: '#8F8F8F',
          timed: false,
        })
      })

      Object.keys(this.equipment).forEach((key) => {
        const equipmentPerDay = this.equipment[key]

        events.push({
          type: 1,
          object: { date: key, myInspections: equipmentPerDay },
          name: 'Vencimento Garantia',
          start: key,
          end: key,
          color: '#238CA5',
          timed: false,
        })
      })

      this.contacts.map((contract) => {
        if (
          contract.endDate != null &&
          contract.endDate.split('T')[0] >= start.date &&
          contract.endDate.split('T')[0] <= end.date
        ) {
          events.push({
            type: 2,
            object: contract,
            name: contract.name,
            start: contract.endDate.split('T')[0],
            end: contract.endDate.split('T')[0],
            color: '#B14949',
            timed: false,
          })
        }
      })

      this.calibrationPattern.map((pattern) => {
        if (
          pattern.certifiedValidate != null &&
          pattern.certifiedValidate.split('T')[0] >= start.date &&
          pattern.certifiedValidate.split('T')[0] <= end.date
        ) {
          events.push({
            type: 3,
            object: pattern,
            name: pattern.name,
            start: pattern.certifiedValidate.split('T')[0],
            end: pattern.certifiedValidate.split('T')[0],
            color: '#BBCF20',
            timed: false,
          })
        }
      })

      this.calibrationV2Pattern.map((pattern) => {
        if (
          pattern.expirationDate != null &&
          pattern.expirationDate.split('T')[0] >= start.date &&
          pattern.expirationDate.split('T')[0] <= end.date
        ) {
          events.push({
            type: 5,
            object: pattern,
            name: pattern.name,
            start: pattern.expirationDate.split('T')[0],
            end: pattern.expirationDate.split('T')[0],
            color: '#BBCF20',
            timed: false,
          })
        }
      })

      Object.keys(this.inspections).forEach((key) => {
        const myInspections = this.inspections[key]

        events.push({
          type: 4,
          object: { date: key, myInspections },
          name: 'Rotina de inspeção',
          start: key,
          end: key,
          color: '#38B890',
          timed: false,
        })
      })

      this.externalFilesControl.map((externalFile) => {
        const expiredDate = externalFile.expiredDate
        if (
          expiredDate != null &&
          expiredDate.split('T') >= start.date &&
          expiredDate.split('T')[0] <= end.date
        ) {
          events.push({
            type: 4,
            object: externalFile,
            name: externalFile.name,
            start: expiredDate,
            end: expiredDate,
            color: '#426483',
            timed: false,
          })
        }
      })

      this.events = events
    },

    async yearEvents(year) {
      this.eventsYear = []

      const events = []
      const eventsYear = []

      Object.keys(this.tasks).forEach((date) => {
        const tasksPerDay = this.tasks[date]
        tasksPerDay.forEach((task) => {
          if (task.showCalendar && Utils.getYear(task.laborDate) == year) {
            events.push({
              type: 0,
              object: task,
              name: task.name,
              start: task.laborDate,
              end: task.laborDate,
              color: '#8F8F8F',
              timed: false,
            })
          }
        })
      })

      Object.keys(this.equipment).forEach((date) => {
        const equipmentPerDay = this.equipment[date]
        equipmentPerDay.forEach((equipment) => {
          if (
            equipment.warrantyEndDate != null &&
            Utils.getYear(equipment.warrantyEndDate) == year
          ) {
            events.push({
              type: 1,
              object: equipment,
              name: `${equipment.identification} - ${equipment.name}`,
              start: equipment.warrantyEndDate.split('T')[0],
              end: equipment.warrantyEndDate.split('T')[0],
              color: '#238CA5',
              timed: false,
            })
          }
        })
      })

      this.contacts.map((contract) => {
        if (
          contract.endDate != null &&
          Utils.getYear(contract.endDate) == year
        ) {
          events.push({
            type: 2,
            object: contract,
            name: contract.name,
            start: contract.endDate.split('T')[0],
            end: contract.endDate.split('T')[0],
            color: '#B14949',
            timed: false,
          })
        }
      })

      this.calibrationPattern.map((pattern) => {
        if (
          pattern.certifiedValidate != null &&
          Utils.getYear(pattern.certifiedValidate) == year
        ) {
          events.push({
            type: 3,
            object: pattern,
            name: pattern.name,
            start: pattern.certifiedValidate.split('T')[0],
            end: pattern.certifiedValidate.split('T')[0],
            color: '#BBCF20',
            timed: false,
          })
        }
      })

      this.calibrationV2Pattern.map((pattern) => {
        if (
          pattern.expirationDate != null &&
          Utils.getYear(pattern.expirationDate) == year
        ) {
          events.push({
            type: 5,
            object: pattern,
            name: pattern.name,
            start: pattern.expirationDate.split('T')[0],
            end: pattern.expirationDate.split('T')[0],
            color: '#BBCF20',
            timed: false,
          })
        }
      })

      this.externalFilesControl.map((externalFile) => {
        if (
          externalFile.expiredDate != null &&
          Utils.getYear(externalFile.expiredDate) == year
        ) {
          events.push({
            type: 4,
            object: externalFile,
            name: externalFile.name,
            start: externalFile.expiredDate,
            end: externalFile.expiredDate,
            color: '#426483',
            timed: false,
          })
        }
      })

      events.forEach((event) => {
        switch (Utils.getMoth(event.start)) {
          case 0:
            eventsYear.push({
              month: 'Janeiro',
              event: event,
            })
            break
          case 1:
            eventsYear.push({
              month: 'Fevereiro',
              event: event,
            })
            break
          case 2:
            eventsYear.push({
              month: 'Março',
              event: event,
            })
            break
          case 3:
            eventsYear.push({
              month: 'Abril',
              event: event,
            })
            break
          case 4:
            eventsYear.push({
              month: 'Maio',
              event: event,
            })
            break
          case 5:
            eventsYear.push({
              month: 'Junho',
              event: event,
            })
            break
          case 6:
            eventsYear.push({
              month: 'Julho',
              event: event,
            })
            break
          case 7:
            eventsYear.push({
              month: 'Agosto',
              event: event,
            })
            break
          case 8:
            eventsYear.push({
              month: 'Setembro',
              event: event,
            })
            break
          case 9:
            eventsYear.push({
              month: 'Outubro',
              event: event,
            })
            break
          case 10:
            eventsYear.push({
              month: 'Novembro',
              event: event,
            })
            break
          case 11:
            eventsYear.push({
              month: 'Dezembro',
              event: event,
            })
            break
        }
      })

      const newEvents = []

      for (var i = 0; i < eventsYear.length; i++) {
        var sameMonth = false

        for (var j = 0; j < i; j++) {
          if (newEvents[j] && eventsYear[i].month == newEvents[j].month) {
            newEvents[j].events.push({
              event: eventsYear[i].event,
            })
            sameMonth = true
            break
          }
        }

        if (!sameMonth) {
          newEvents.push({
            month: this.$t(eventsYear[i].month),
            events: [
              {
                event: eventsYear[i].event,
              },
            ],
          })
        }
      }

      this.months.forEach((month) => {
        const monthEvents = newEvents.filter((x) => x.month == month)

        if (monthEvents.length == 0) {
          this.eventsYear.push({
            month: month,
            events: [],
          })
        } else {
          monthEvents.map((event) => {
            this.eventsYear.push({
              month: event.month,
              events: event.events,
            })
          })
        }
      })
    },

    async getTasks(start, end) {
      await this.apiService
        .get(`labor/list/${this.institutionId}`)
        .then((response) => {
          let tasks = response.content

          tasks = tasks.filter(
            (task) =>
              task.laborDate.split('T')[0] >= start.date &&
              task.laborDate.split('T')[0] <= end.date
          )

          tasks = tasks.map((task) => {
            const [date, time] = task.laborDate.split('T')
            return {
              ...task,
              laborDate: date,
              laborTime: time ? time.split('.')[0] : '',
            }
          })

          this.tasks = this.groupBy(tasks, 'laborDate')
        })
    },

    async getEquipment(start, end) {
      await this.apiService
        .get(`equipment/list/${this.institutionId}`)
        .then((response) => {
          let equipment = response.content

          equipment = equipment.filter(
            (eq) =>
              eq.warrantyEndDate != null &&
              eq.warrantyEndDate.split('T')[0] >= start.date &&
              eq.warrantyEndDate.split('T')[0] <= end.date
          )

          equipment = equipment.map((eq) => {
            return {
              ...eq,
              warrantyEndDate: eq.warrantyEndDate.split('T')[0],
            }
          })

          this.equipment = this.groupBy(equipment, 'warrantyEndDate')
        })
    },

    async getContracts() {
      await this.apiService
        .get(`contract/listAll/${this.institutionId}`)
        .then((response) => {
          this.contacts = response.content
        })
    },

    async getInspections(start, end) {
      const model = {
        institutionId: this.institutionId,
        start: start.date,
        end: end.date,
        type: 4,
      }

      await this.apiService
        .post(`serviceOrder/list-by-type-and-date`, model)
        .then((response) => {
          let inspections = response.content

          inspections = inspections.map((x) => {
            return {
              ...x,
              dateTimeRequest: x.dateTimeRequest.split('T')[0],
            }
          })

          this.inspections = this.groupBy(inspections, 'dateTimeRequest')
        })
    },

    groupByDepartment(list) {
      const newList = this.groupBy(list, 'departmentId')

      const result = []

      Object.keys(newList).forEach((key) => {
        const listPerDepartment = newList[key]

        const finalInspection = {
          department:
            listPerDepartment[0].equipment &&
            listPerDepartment[0].equipment.department &&
            listPerDepartment[0].equipment.department.unidade
              ? `${listPerDepartment[0].equipment.department.name} - ${listPerDepartment[0].equipment.department.unidade.initials}`
              : listPerDepartment[0].department &&
                listPerDepartment[0].department.unidade
              ? `${listPerDepartment[0].department.name} - ${listPerDepartment[0].department.unidade.initials}`
              : '',
          listPerDepartment,
        }

        result.push(finalInspection)
      })

      console.log('RESULT')
      console.log(result)

      return result
    },

    async getCalibrationPatterns() {
      await this.apiService
        .get(`calibrationPattern/list/${this.institutionId}`)
        .then((response) => {
          this.calibrationPattern = response.content
        })
    },

    async getCalibrationV2Patterns() {
      await this.apiService
        .get(`calibration/v2/pattern/list/${this.institutionId}`)
        .then((response) => {
          this.calibrationV2Pattern = response.content
        })
    },

    async getExternalFilesControl() {
      await this.apiService.get('externalFileControl/list').then((response) => {
        this.externalFilesControl = response.content
      })
    },

    formatDate(date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
  },
}
